import { render, staticRenderFns } from "./public-info.vue?vue&type=template&id=28d02409&scoped=true"
import script from "./public-info.vue?vue&type=script&lang=js"
export * from "./public-info.vue?vue&type=script&lang=js"
import style0 from "./public-info.vue?vue&type=style&index=0&id=28d02409&prod&scoped=true&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "28d02409",
  null
  
)

export default component.exports